module.exports = __webpack_public_path__ + "static/media/FBX.51e41b38.png";